import React, { useContext, useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Button, Stack } from '@mui/material';
import { Download, Delete, PictureAsPdf, ArrowUpward, ArrowDownward  } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import ProtectedAction from './ProtectedAction';
import { formatDate } from '../utils/dateFormatter';

export default function DocumentoFascicoloTable({ documenti, contribuenteId, onDownload, onDelete,onHandleSort }) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [sortField, setSortField] = useState('dataUpload');
  const [sortDirection, setSortDirection] = useState('DESC'); // ASC o DESC
  console.log("DocumentoFascicoloTable contribuenteId",contribuenteId);
  const handleCreaScadenze = (doc) => {
    // Naviga a DocumentoUploadPage passando documentoFascicoloId
    navigate(`/contribuenti/${contribuenteId}/documenti/upload`, { state: { documentoFascicoloId: doc.id } });
  };
  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell onClick={() => onHandleSort('tipo')} style={{ cursor: 'pointer' }}>Tipo {renderSortIcon('tipo')}</TableCell>
          <TableCell>Descrizione</TableCell>
          <TableCell>Versione</TableCell>
          <TableCell>Data Caricamento</TableCell>
          <TableCell>Caricato Da</TableCell>
          <TableCell>Azioni</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {documenti.map((d) => (
          <TableRow key={d.id}>
            <TableCell>{d.tipo}</TableCell>
            <TableCell>{d.descrizione}</TableCell>
            <TableCell>{d.versione}</TableCell>
            <TableCell>{formatDate(d.dataUpload)}</TableCell>
            <TableCell>{d.caricatoDa}</TableCell>
            <TableCell>
              <Stack direction="row" spacing={1}>
                <ProtectedAction user={user} contractState={user.statoContratto}>
                  <IconButton color="error" onClick={() => onDownload(d.id, d.nomeFile)}>
                    <PictureAsPdf />
                  </IconButton>
                  <IconButton color="error" onClick={() => onDelete(d.id)}>
                    <Delete />
                  </IconButton>
                  {/* Bottone crea scadenze solo per F24 e RATEIZZAZIONE_ADE */}
                  {((d.parsedandloaded==null || !(d.parsedandloaded===true)) && (d.tipo === 'F24' || d.tipo === 'RATEIZZAZIONE_ADE')) && (
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() => handleCreaScadenze(d)}
                    >
                      Crea Scadenze {d.parsedandloaded}
                    </Button>
                  )}
                </ProtectedAction>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}